import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  margin: {
    '& > *': {
      margin: theme.spacing(1, 0, 1, 1),
      float: 'right',
    },
  },
  marginLeft: {
    '& > *': {
      margin: theme.spacing(1, 0, 2, 0),
      float: 'left',
    },
    '& > p': {
      margin: theme.spacing(0, 0, 1, 0),
      float: 'left',
    },
  },
}));

export default useStyles;
